import { cx } from '@linaria/core';

import type { SmartElementProps } from '~shared/ui/atoms/SmartElement/types';

import LoaderIcon from '../../../../../public/assets/icons/buttonLoader.svg';
import { SmartElement } from '../SmartElement';
import { Loader, styledButton, styledButtonBaseFullWidth } from './styles';
import type { ButtonBaseProps } from './types';

export const ButtonBase = ({
	children,
	borderRadius = 'XL',
	fullWidth,
	className,
	loading,
	selected,
	disabled,
	disabledInteraction,
	...props
}: ButtonBaseProps) => {
	return (
		<SmartElement
			className={cx(
				styledButton,
				`borderRadius${borderRadius}`,
				loading && 'loading',
				selected && 'selected',
				disabled && 'disabled',
				disabledInteraction && 'disabledInteraction',
				fullWidth && styledButtonBaseFullWidth,
				className
			)}
			disabled={disabled || loading}
			{...(props as SmartElementProps)}
		>
			{children}
			{loading && (
				<Loader className="loader">
					<LoaderIcon />
				</Loader>
			)}
		</SmartElement>
	);
};
